import { RiskLevel } from '../../../common/entities/risk-level.entity';
import { RISK_LEVELS } from '../../../common/utils/risk-level.util';
import { CorrectiveActionStatus } from '../../application/entities/corrective-action-status.entity';
import { CorrectiveActionSummary } from '../../application/entities/corrective-action-summary.entity';
import { RecentCorrectiveActionItemDto } from '../dto/recent-corrective-actions-response.dto';

/**
 * Consultor de la fila según el estado de la medida:
 * assigned / in_progress -> assignedToName; not_started / pending -> managerName;
 * si no hay ninguno de los dos, consultantName (ingeniero consultor del análisis).
 */
export function toConsultantName(dto: RecentCorrectiveActionItemDto): string {
  const byStatus =
    dto.status === 'assigned' || dto.status === 'in_progress'
      ? dto.assignedToName
      : dto.status === 'not_started' || dto.status === 'pending'
        ? dto.managerName
        : null;
  return byStatus || dto.consultantName || '';
}

export function toCorrectiveActionSummary(dto: RecentCorrectiveActionItemDto): CorrectiveActionSummary {
  return {
    id: dto.uuid,
    action: dto.description ?? '',
    reference: dto.reference ?? '',
    analysisId: dto.analysisUuid ?? '',
    analysisTitle: dto.analysisTitle ?? '',
    consultant: toConsultantName(dto),
    riskLevel: (RISK_LEVELS as readonly string[]).includes(dto.riskLevel ?? '')
      ? (dto.riskLevel as RiskLevel)
      : null,
    status: dto.status as CorrectiveActionStatus,
  };
}
